import { isIpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import { IpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';
import { handleInitialAppRequest } from 'components/GlobalState/commands/handleInitialAppRequest';
import { login } from 'components/GlobalState/commands/login';

/**
 * Initialize authentication when returning from SSO /auth-callback.
 * Expects accessToken in query params, performs login.
 * @param cmdContext Global state command context
 * @param dispatch Global state command dispatcher
 */
export const initializeSSOAuthentication: GlobalStateCommandFactory =
  (cmdContext, dispatch) => async () => {
    try {
      await dispatch(handleInitialAppRequest, async () => {
        // We only call this command when pathname === '/auth-callback'
        const urlParams = new URLSearchParams(window.location.search);
        const accessToken = urlParams.get('accessToken');
        if (!accessToken) {
          throw new IpfError('GENERIC', 'No access token provided.');
        }
        await dispatch(login, { accessToken });
      });
    } catch (e) {
      if (isIpfError(e)) {
        cmdContext.showNotification({
          type: 'danger',
          message: `Login failed: ${e.message}`,
        });
        cmdContext.updateState((draft) => {
          draft.loginStatus = 'LOGGED_OUT';
        });
        // Redirect to /logout to clear any partial state
        // if user would call SSO auth during an existing session then he would be still logged in but on login page
        // which could lead to a false sense of being logged out - so we rather just log him out completely
        cmdContext.navigate('/logout');
        return;
      }
      throw e; // non-IPF errors bubble up
    }
  };
